import Header from './header/Header'
import ContactTabs from './contact/ContactTabs'
import Achievements from './achievements/Achievements'
import Leagues from './leagues/Leagues'
import CallToAction from './call_to_action/CallToAction'
import PicturesAndText1 from './about/about_overview/PicturesAndText1'
import Huddle from './about/about_overview/Huddle'
import CollegePageHeader from './college/Header'
import CallToAction2 from './call_to_action/CallToAction2'
import Partners from './partners/Partners'

const Home = () => {
  return (
    <>
       <Header/> 
       <Achievements/>
       <CollegePageHeader/>
       <Leagues/>
       <CallToAction2/>
       <PicturesAndText1/>
       <Huddle/>
       <CallToAction/>
       <Partners/>
       <ContactTabs/>
    </>
  )
}

export default Home